var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRotateCounterclockwiseTool = function SvgRotateCounterclockwiseTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.443 6.714L1.066 5.336 0 6.402l3.196 3.195 3.196-3.195-1.066-1.066-1.377 1.378V4.766a2.26 2.26 0 012.26-2.26H9.22V1H6.21a3.766 3.766 0 00-3.766 3.766v1.948zm5.272-1.195a.753.753 0 00-.753.753v7.532a.753.753 0 00.753.753h7.532a.753.753 0 00.753-.753V6.272a.753.753 0 00-.753-.753H7.715zm.753 1.507h6.026v6.025H8.468V7.026z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rotate-counterclockwise-tool_svg__clip0_627_959"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 16 0)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgRotateCounterclockwiseTool;